<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'dashboard/composables/store';
import { useInbox } from 'dashboard/composables/useInbox';
import { useWhatsappCall } from 'dashboard/composables/useWhatsappCall';
import { useAlert } from 'dashboard/composables';
import { emitter } from 'shared/helpers/mitt';
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  conversation: { type: Object, default: () => ({}) },
});

const { t } = useI18n();
const store = useStore();

// Gate: only show for WhatsApp Cloud inboxes whose channel record has
// provider_config['calling_enabled'] == true (set per-inbox, not per-account).
const { isAWhatsAppCloudChannel, isCallingEnabled } = useInbox();

const shouldRender = computed(
  () => isAWhatsAppCloudChannel.value && isCallingEnabled.value
);

const { startCall } = useWhatsappCall();

const onClick = async () => {
  const conversationId = props.conversation?.id;
  const contactName = props.conversation?.meta?.sender?.name || '';
  const phone = props.conversation?.meta?.sender?.phone_number || '';

  store.dispatch('whatsappCall/setActiveCall', {
    conversationId,
    contactName,
    phone,
  });

  try {
    const { callId, recordId, status } = await startCall(conversationId);
    store.dispatch('whatsappCall/setActiveCall', { callId, recordId });
    store.dispatch('whatsappCall/setStatus', status);
  } catch (e) {
    // I1: always reset the store first so no phantom "Calling…" panel is left open
    store.dispatch('whatsappCall/reset');
    if (e.errorCode === '138006') {
      emitter.emit('whatsapp_call:permission_required', { conversationId });
    } else {
      useAlert(t('CONVERSATION.WHATSAPP_CALL.ERROR_GENERIC'));
    }
  }
};
</script>

<template>
  <span class="contents">
    <Button
      v-if="shouldRender"
      v-tooltip.top-end="t('CONVERSATION.WHATSAPP_CALL.CALL')"
      icon="i-ph-phone"
      sm
      faded
      slate
      @click="onClick"
    />
  </span>
</template>
